import { useEffect, useState, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface Props {
  children: ReactNode;
}

export default function ProtectedAdminRoute({ children }: Props) {
  const [state, setState] = useState<'loading' | 'allowed' | 'denied'>('loading');

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) {
        if (mounted) setState('denied');
        return;
      }
      const { data, error } = await supabase.rpc('has_role', {
        _user_id: session.user.id,
        _role: 'admin' as any,
      });
      if (mounted) setState(!error && data === true ? 'allowed' : 'denied');
    })();
    return () => { mounted = false; };
  }, []);

  if (state === 'loading') {
    return <div className="min-h-screen bg-background flex items-center justify-center text-muted-foreground">Checking access…</div>;
  }
  if (state === 'denied') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
